import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import Logo from "../components/navbar/Logo";
import Section from "../components/common/Section";
import AuthBasicRoutes from "../components/auth/AuthBasicRoutes";

const AuthBasicLayout = () => <AuthBasicRoutes />;

export default AuthBasicLayout;
